export enum RoutePath {
  base = '',
  interconnectors = 'interconnectors',
  generators = 'nem-generators',
  vwap = 'nem-vwap',
  renewable = 'renewable-summary',
  regional = 'regional',
  tasks = 'tasks',
  onDemand = 'on-demand',
  settings = 'settings',
  focusmode = 'focus-mode/:id/:method',
  paperEditor = 'paper-editor',
  wildcard = '**'
}

export const NAVIGATION = [
  // L'onglet "About" est supprimé. La vue par défaut est maintenant Regional NEM.

  {
    label: 'Regional NEM',
    routerLink: `/dashboard/${RoutePath.regional}`,
    tooltip: ''
  },
  {
    label: 'NEM Generators',
    routerLink: `/dashboard/${RoutePath.generators}`,
    tooltip: ''
  },
  {
    label: 'NEM Vwap',
    routerLink: `/dashboard/${RoutePath.vwap}`,
    tooltip: 'Volume weighted average price'
  },
  {
    label: 'Renewable Summary',
    routerLink: `/dashboard/${RoutePath.renewable}`,
    tooltip: ''
  },
  {
    label: 'Interconnectors',
    routerLink: `/dashboard/${RoutePath.interconnectors}`,
    tooltip: ''
  },

  // === ROUTES ADMIN ===
  {
    label: 'Scraper tasks',
    routerLink: `/dashboard/${RoutePath.tasks}`,
    tooltip: '',
    groups: ['admin']
  },
  {
    label: 'On Demand data',
    routerLink: `/dashboard/${RoutePath.onDemand}`,
    tooltip: '',
    groups: ['admin']
  },
  {
    label: 'Settings',
    routerLink: `/dashboard/${RoutePath.settings}`,
    tooltip: '',
    groups: ['admin']
  }
];
